import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=07c37eb8&scoped=true&"
import script from "./editPassword.vue?vue&type=script&lang=js&"
export * from "./editPassword.vue?vue&type=script&lang=js&"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=07c37eb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c37eb8",
  null
  
)

export default component.exports